// File: frontend/src/pages/SuperAdmin/components/common/BarChart/index.js

import React from 'react';
import styles from './BarChart.module.css';

const BarChart = ({ 
  data, 
  valueKey = 'count', 
  colorFn, 
  formatFn = (value) => value,
  total
}) => {
  // Calculate total if not provided
  const calculatedTotal = total || Object.values(data).reduce((sum, item) => sum + (item[valueKey] || 0), 0);
  
  return (
    <div className={styles.barChartContainer}>
      {Object.entries(data).map(([key, value]) => (
        <div className={styles.barChartItem} key={key}>
          <div className={styles.barLabel}>{key}</div>
          <div className={styles.barContainer}>
            <div 
              className={styles.bar}
              style={{ 
                width: `${((value[valueKey] || 0) / calculatedTotal) * 100}%`,
                backgroundColor: colorFn ? colorFn(key) : 'var(--color-primary)'
              }}
            ></div>
          </div>
          <div className={styles.barValue}>{formatFn(value[valueKey] || 0)}</div>
        </div>
      ))}
    </div>
  );
};

export default BarChart;